import React, { useState } from 'react'
import { useSelector } from 'react-redux'

import { hasVouchers as hasVouchersSelector } from '../../../selectors/selectors'
import LinkAddVoucher from '../../voucher/LinkAddVoucher/LinkAddVoucher'
import VoucherPanel from '../../VoucherPanel/VoucherPanel'

export default function DesktopVouchers() {
  const hasVouchers = useSelector(hasVouchersSelector)
  const [voucherPanelVisible, setVoucherPanelVisible] = useState(false)

  const openVoucherPanel = () => setVoucherPanelVisible(true)
  const closeVoucherPanel = () => setVoucherPanelVisible(false)

  return hasVouchers || voucherPanelVisible ? (
    <VoucherPanel
      onCancelAddNewVoucher={() => !hasVouchers && closeVoucherPanel()}
      onRemoveLastVoucher={closeVoucherPanel}
    />
  ) : (
    <LinkAddVoucher onClick={openVoucherPanel} />
  )
}
